import { getDecimalValue } from './decimalWrapper';
export const convertDecimalIntoPercentage = (num) => Math.round(num * 100) + '%';
export const getPercentageAmountFromDecimal = (amount) => {
    if (!amount)
        return 0;
    const tempAmount = getDecimalValue(amount);
    return tempAmount.times(100).toNumber();
};
export const getDecimalFromPercentage = (amount) => {
    if (!amount)
        return 0;
    const tempAmount = getDecimalValue(amount);
    return tempAmount.dividedBy(100).toNumber();
};
export const getPercentageWithSymbol = (amount) => {
    return getPercentageAmountFromDecimal(amount) + '%';
};
export const roundDecimal = (amount, decimalPrecision = 2) => getDecimalValue(amount).toDecimalPlaces(decimalPrecision).toNumber();
//# sourceMappingURL=percentage.js.map